import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

const addExternalMedia = async (
  module,
  { url, externalType, name, isCollection, opts = {} }
) => {
  const api = useApiStore();
  const { rootGetters, dispatch } = module;
  const config = Object.assign(getDefaultOpts(), opts);
  const id = isCollection ? rootGetters.getClientID : rootGetters.getStyleID;
  const docType = isCollection ? "collection" : "siteID";
  const { data } = await dispatch("httpRequest", {
    func: api.addExternalMedia(docType, id, url, externalType, name),
    config,
  });
  return data;
};

export { addExternalMedia };
